import { render } from "./Bottom.vue?vue&type=template&id=8fbc3cc4"
import script from "./Bottom.vue?vue&type=script&lang=js"
export * from "./Bottom.vue?vue&type=script&lang=js"

import "./Bottom.vue?vue&type=style&index=0&id=8fbc3cc4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__